import { skillAcquisitionDomainActionTypes } from '../constants/ApiConstants';

const initialState = {
  loading: false,
  masterData: [],
  skillAcquisitionDomainList: null,
  skillAcquisitionDomainDetail: null,
  saved_skillAcquisitionDomain: null,
  deleted_skillAcquisitionDomain: null,
  saved_masterDomainDetails: null,
  skillAcquisitionArchivedDomainList: null,
  skillAcquisitionArchivedProgramList: null,
  skillAcquisitionArchivedTargetList: null,
  domainList : null,
  programList : null,
  copyLibraryCurriculumData : null,
  skillAcquisitionProgramOne : null,
  skillAcquisitionProgramTwo : null,
  moveProgramDomainData : null,

};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case skillAcquisitionDomainActionTypes.get_masterData.REQUEST:
      return {
        ...state,
        loading: true,
        masterData: null,
      };
    case skillAcquisitionDomainActionTypes.get_masterData.SUCCESS:
      return {
        ...state,
        loading: false,
        masterData: payload,
      };
    case skillAcquisitionDomainActionTypes.save_skillAcquisitionDomain.REQUEST:
      return {
        ...state,
        loading: true,
        saved_skillAcquisitionDomain: null,
      };
    case skillAcquisitionDomainActionTypes.save_skillAcquisitionDomain.SUCCESS:
      return {
        ...state,
        loading: false,
        saved_skillAcquisitionDomain: payload,
      };
    case skillAcquisitionDomainActionTypes.get_skillAcquisitionDomainList.REQUEST:
      return {
        ...state,
        loading: true,
        skillAcquisitionDomainList: null,
      };
    case skillAcquisitionDomainActionTypes.get_skillAcquisitionDomainList.SUCCESS:
      return {
        ...state,
        loading: false,
        skillAcquisitionDomainList: payload,
      };
    case skillAcquisitionDomainActionTypes.get_skillAcquisitionDomainDetail.REQUEST:
      return {
        ...state,
        loading: true,
        skillAcquisitionDomainDetail: null,
      };
    case skillAcquisitionDomainActionTypes.get_skillAcquisitionDomainDetail.SUCCESS:
      return {
        ...state,
        loading: false,
        skillAcquisitionDomainDetail: payload,
      };
    case skillAcquisitionDomainActionTypes.delete_skillAcquisitionDomain.REQUEST:
      return {
        ...state,
        loading: true,
        deleted_skillAcquisitionDomain: null,
      };
    case skillAcquisitionDomainActionTypes.delete_skillAcquisitionDomain.SUCCESS:
      return {
        ...state,
        loading: false,
        deleted_skillAcquisitionDomain: payload,
      };
    case skillAcquisitionDomainActionTypes.post_masterDomainDetails.REQUEST:
      return {
        ...state,
        loading: true,
        saved_masterDomainDetails: null,
      }
    case skillAcquisitionDomainActionTypes.post_masterDomainDetails.REQUEST:
      return {
        ...state,
        loading: true,
        saved_masterDomainDetails: payload,
      }
    case skillAcquisitionDomainActionTypes.get_skillAcquisitionArchivedDomainList.REQUEST:
      return {
        ...state,
        loading: true,
        skillAcquisitionArchivedDomainList: null,
        skillAcquisitionArchivedProgramList: null,
        skillAcquisitionArchivedTargetList: null,
      };
    case skillAcquisitionDomainActionTypes.get_skillAcquisitionArchivedDomainList.SUCCESS:
      return {
        ...state,
        loading: false,
        skillAcquisitionArchivedDomainList: payload,
      };  
    case skillAcquisitionDomainActionTypes.get_skillAcquisitionArchivedProgramList.REQUEST:
      return {
        ...state,
        loading: true,
        skillAcquisitionArchivedProgramList: null,
      };
    case skillAcquisitionDomainActionTypes.get_skillAcquisitionArchivedProgramList.SUCCESS:
      return {
        ...state,
        loading: false,
        skillAcquisitionArchivedProgramList: payload,
      }; 
    case skillAcquisitionDomainActionTypes.get_skillAcquisitionArchivedTargetList.REQUEST:
      return {
        ...state,
        loading: true,
        skillAcquisitionArchivedTargetList: null,
      };
    case skillAcquisitionDomainActionTypes.get_skillAcquisitionArchivedTargetList.SUCCESS:
      return {
        ...state,
        loading: false,
        skillAcquisitionArchivedTargetList: payload,
      }; 
      case skillAcquisitionDomainActionTypes.get_domainList.REQUEST:
            return {
                ...state, 
                loading: true,
                domainList: null
            };
        case skillAcquisitionDomainActionTypes.get_domainList.SUCCESS:
            return {
                ...state,
                loading: false,
                domainList: payload
            };
            case skillAcquisitionDomainActionTypes.get_programList.REQUEST:
              return {
                ...state,
                loading: true,
                programList: null
            };
        case skillAcquisitionDomainActionTypes.get_programList.SUCCESS:
            return {
                ...state,
                loading: false,
                programList: payload
            };
            case skillAcquisitionDomainActionTypes.post_patientSkillAcquisitionData.REQUEST:
              return {
                ...state,
                loading: true,
                copyLibraryCurriculumData: null
            };
        case skillAcquisitionDomainActionTypes.post_patientSkillAcquisitionData.SUCCESS:
            return {
                ...state,
                loading: false,
                copyLibraryCurriculumData: payload
            };

            case skillAcquisitionDomainActionTypes.get_skillAcquisitionProgramList.REQUEST:
      return {
        ...state,
        loading: true,
        skillAcquisitionProgramOne: null,
      };
    case skillAcquisitionDomainActionTypes.get_skillAcquisitionProgramList.SUCCESS:
      return {
        ...state,
        loading: false,
        skillAcquisitionProgramOne: payload,
      };
            case skillAcquisitionDomainActionTypes.get_skillAcquisitionProgramListForMove.REQUEST:
      return {
        ...state,
        loading: true,
        skillAcquisitionProgramTwo: null,
      };
    case skillAcquisitionDomainActionTypes.get_skillAcquisitionProgramListForMove.SUCCESS:
      return {
        ...state,
        loading: false,
        skillAcquisitionProgramTwo: payload,
      };
    case skillAcquisitionDomainActionTypes.get_skillAcquisitionProgramListForMoveReset.SUCCESS:
      return {
        ...state,
        loading: false,
        skillAcquisitionProgramTwo: null,
      };

            case skillAcquisitionDomainActionTypes.move_patientSkillAcquisitionData.REQUEST:
              return {
                ...state,
                loading: true,
                moveProgramDomainData: null
            };
        case skillAcquisitionDomainActionTypes.move_patientSkillAcquisitionData.SUCCESS:
            return {
                ...state,
                loading: false,
                moveProgramDomainData: payload
            };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SkillAquisition/components/Domain/reducers/skillAquisitionDomainReducer.js